import { css } from '@/styled-system/css';

export const propertyCardMLSLogoStyles = css.raw({
  'display': 'grid',
  'gridArea': 'mls-logo',
  'justifyItems': 'end',
  'paddingBlock': 'tightest',
  'paddingInline': 'tightest',

  '& img, & picture': {
    maxBlockSize: '23px',
    maxInlineSize: '100px',
  },
});
